import { scopeClass } from "@dinesh-gamage/react-scoped-css";
import React, { useEffect } from "react";
import { Legend, ResponsiveContainer, Tooltip, CartesianGrid, BarChart, XAxis, YAxis, Bar } from "recharts";
import { FormField, Label, Select } from "uxp/components";
import { distinct } from "@utils";
import './BarChartPreview.scss';
export const BarChartPreview = props => {
    var _a, _b;
    const [valueField, setValueField] = React.useState('');
    const [labelField, setLabelField] = React.useState('');
    const [groupField, setGroupField] = React.useState('');
    const type = 'pie';
    const chartSize = 80;
    const colors = ['#669FEC', '#5652C2', '#BC59C3', '#BB597B', '#72C1C7', '#ABE087', '#C76663'];
    function getTooltipText(item) {
        if (groupField) {
            return `${item === null || item === void 0 ? void 0 : item[groupField]} - ${item === null || item === void 0 ? void 0 : item[labelField || 'name']} : ${item === null || item === void 0 ? void 0 : item[valueField || 'value']}`;
        }
        return `${item === null || item === void 0 ? void 0 : item[labelField || 'name']} : ${item === null || item === void 0 ? void 0 : item[valueField || 'value']}`;
    }
    let schema = props.schema || [];
    useEffect(() => {
        if (props.schema && !valueField) {
            let item = schema.find(x => x.type == 'number');
            if (item) {
                setValueField(item.name);
            }
        }
        if (schema && !labelField) {
            let item = schema.find(x => x.type == 'string');
            console.log('IMTEIZE', item, schema);
            if (item) {
                setLabelField(item.name);
            }
        }
    }, [props.schema]);
    let numericFields = schema.filter(x => x.type == 'number');
    if (numericFields.length == 0) {
        numericFields = schema;
    }
    let transformedData = (_a = props.data) === null || _a === void 0 ? void 0 : _a.map((x) => {
        var y = Object.assign({}, x);
        y[valueField] = Number(y[valueField]);
        return y;
    });
    let chartGroups = [{
            data: transformedData,
            color: colors[0]
        }];
    if (groupField) {
        let groups = distinct(props.data, groupField);
        if (groups.length > 1) {
            let i = 0;
            chartGroups = [];
            for (let group of groups) {
                let groupData = props.data.filter((x) => { var _a, _b, _c; return ((_b = (_a = x[groupField]) === null || _a === void 0 ? void 0 : _a.toLowerCase) === null || _b === void 0 ? void 0 : _b.call(_a)) == ((_c = group === null || group === void 0 ? void 0 : group.toLowerCase) === null || _c === void 0 ? void 0 : _c.call(group)); });
                chartGroups.push({
                    data: groupData,
                    color: colors[i % colors.length]
                });
                i++;
            }
        }
    }
    return React.createElement("div", { className: "qe-preview-pie-chart-cc76cb99" },
        React.createElement("div", { className: "qe-preview-chart-props-cc76cb99" },
            React.createElement(FormField, null,
                React.createElement(Label, null, "Y-Axis"),
                React.createElement(Select, { renderOption: (option, key) => React.createElement("div", { className: scopeClass('qe-chart-select-option ' + (option.type == 'number' ? '' : 'disabled'), "cc76cb99", ["uxpcore-", "uxpcore_", "uxp-", "leaflet-", "react-resizable", "react-grid", "modal-"]) }, option.name), onChange: setValueField, options: schema, labelField: "name", valueField: "name", selected: valueField })),
            React.createElement(FormField, null,
                React.createElement(Label, null, "X-Axis"),
                React.createElement(Select, { renderOption: (option, key) => React.createElement("div", { className: scopeClass('qe-chart-select-option ' + (option.type == 'string' ? '' : 'disabled'), "cc76cb99", ["uxpcore-", "uxpcore_", "uxp-", "leaflet-", "react-resizable", "react-grid", "modal-"]) }, option.name), onChange: setLabelField, options: schema, labelField: "name", valueField: "name", selected: labelField })),
            React.createElement(FormField, null,
                React.createElement(Label, null, "Group By"),
                React.createElement(Select, { renderOption: (option, key) => React.createElement("div", { className: scopeClass('qe-chart-select-option ' + (option.type == 'string' ? '' : 'disabled'), "cc76cb99", ["uxpcore-", "uxpcore_", "uxp-", "leaflet-", "react-resizable", "react-grid", "modal-"]) }, option.name), onChange: setGroupField, options: schema, labelField: "name", valueField: "name", selected: groupField }))),
        React.createElement("div", { className: "qe-preview-cc76cb99" },
            React.createElement("div", { className: "qe-preview-chart-area-cc76cb99" }, valueField && labelField ? React.createElement(ResponsiveContainer, { width: "100%", height: "100%" },
                React.createElement(BarChart
                //   width={500}
                //   height={300}
                , { 
                    //   width={500}
                    //   height={300}
                    data: (_b = props.data) === null || _b === void 0 ? void 0 : _b.map((x) => {
                        var y = Object.assign({}, x);
                        y[valueField] = Number(y[valueField]);
                        return y;
                    }), margin: {
                        top: 10,
                        right: 10,
                        left: 10,
                        bottom: 10
                    } },
                    React.createElement(CartesianGrid, { strokeDasharray: "3 3" }),
                    React.createElement(XAxis, { dataKey: labelField }),
                    React.createElement(YAxis, null),
                    React.createElement(Tooltip, { content: props => {
                            var _a, _b;
                            return React.createElement("div", { className: "wd-chart-tooltip-cc76cb99" },
                                React.createElement("div", { className: "label-cc76cb99" }, getTooltipText((_b = (_a = props === null || props === void 0 ? void 0 : props.payload) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.payload)));
                        } }),
                    React.createElement(Legend, { formatter: (v, e, i) => { var _a, _b; return ((_b = (_a = props.data) === null || _a === void 0 ? void 0 : _a[i]) === null || _b === void 0 ? void 0 : _b[labelField || 'name']) || 'Unknown'; } }),
                    chartGroups.map((group, i) => React.createElement(Bar, { dataKey: valueField, stackId: 'g' + i, fill: group.color, data: group.data })))) : React.createElement("div", { className: "pie-chart-info-cc76cb99" }, "Select a field to plot"))));
};
